import { Box } from "@mui/material";
import PropTypes from "prop-types";

export default function Container({ children, sx, ...props },) {
  return (
    <Box
      sx={{
        backgroundColor: "white.main",
        borderRadius: "28px",
        "@media (min-width:900px)": {
          padding: "32px"
        },
        padding: "30px",
        ...sx
      }}
      {...props}>
      {children}
    </Box>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
